import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FamilyFilterOptions } from "../models";
import { RootState } from "./store";

export interface PageState {
  familiesFilters: FamilyFilterOptions;
}

const initialState: PageState = {
  familiesFilters: { showInactive: false },
};

export const pageStateSlice = createSlice({
  name: "pageState",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setFamiliesFilters: (state, action: PayloadAction<FamilyFilterOptions>) => {
      state.familiesFilters = action.payload;
    },
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  extraReducers: (_builder) => {},
});

export const { setFamiliesFilters } = pageStateSlice.actions;

export const selectFamiliesFilters = (state: RootState): FamilyFilterOptions => state.pageState.familiesFilters;

export default pageStateSlice.reducer;
